var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rounded-lg",attrs:{"width":_vm.width,"color":"siiAzul","flat":""}},[_c('v-card-text',[_c('v-card',{staticClass:"rounded-lg",attrs:{"elevation":"5"}},[_c('v-card-text',[_vm._t("body")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }